import React from 'react';
import PropTypes from 'prop-types';

const SubTitle = ({ children, className, style }) => (
  <div className={`title is-size-5 is-flex ${className || ''}`} style={style || {}}>
    <p
      style={{
        width: '6px',
        height: '100%',
        backgroundColor: '#363636',
        marginRight: '10px',
        borderRadius: '3px'
      }}
    >
      &nbsp;
    </p>
    <p>{children}</p>
  </div>
);

SubTitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.any // eslint-disable-line
};

SubTitle.defaultProps = {
  className: null,
  style: null // eslint-disable-line
};

export default SubTitle;
